const reactSelectTheme = (theme) => ({
  ...theme,
  borderRadius: 4,
  colors: {
    ...theme.colors,
    primary50: "var(--gc-table-hover-background)",
    primary25: "var(--gc-table-hover-background)",
    neutral0: "var(--gc-default-background)",
    neutral70: "var(--gc-default-text-color)",
    neutral80: "var(--gc-default-text-color)",
    neutral90: "var(--gc-default-text-color)",
  },
});

export default reactSelectTheme;
